import {
    ERROR_MESSAGES
} from 'constants/validation-error-messages';
import * as yup from 'yup';

export const schemaUpdateUser = yup.object({
    first_name: yup
        .string()
        .required(ERROR_MESSAGES.REQUIRED)
        .max(255, ERROR_MESSAGES.MAX_LENGTH),
    last_name: yup
        .string()
        .required(ERROR_MESSAGES.REQUIRED)
        .max(255, ERROR_MESSAGES.MAX_LENGTH),
    workplace_name: yup
        .string()
        .required(ERROR_MESSAGES.REQUIRED)
        .max(255, ERROR_MESSAGES.MAX_LENGTH)
});